/**
 *  @fileOverview Header module
 *
 *  @author       Aaron Chapman
 *
 */

function HeaderModule () {
  const header = document.querySelector('.header')
  const siteHeader = document.querySelector('.siteHeader')

  this.init = function () {
    window.addEventListener('scroll', scrollWatch)
  }

  let scrollWatch = function () {
    let scrollPosition = document.documentElement.scrollTop || document.body.scrollTop

    if (scrollPosition === 0) {
      window.requestAnimationFrame(removeHeader)
    } else if (scrollPosition >= siteHeader.offsetTop) {
      window.requestAnimationFrame(addHeader)
    }
  }

  let addHeader = function () {
    header.classList.add('header--scrolled')
  }

  let removeHeader = function () {
    header.classList.remove('header--scrolled')
  }
}
module.exports = HeaderModule
